import { render, staticRenderFns } from "./ComponentAlertHub.vue?vue&type=template&id=614919c4"
import script from "./ComponentAlertHub.vue?vue&type=script&lang=js"
export * from "./ComponentAlertHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports